<template>
  <b-row v-if="!dataLoad">
    <b-col

      cols="12"
      md="8"
    >
      <SelectDateReq
        :show-date-input="true"
      />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <SearchBtnAction
        :view-search-btn="true"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />
    </b-col>
  </b-row>
</template>

<script>
import SelectDateReq from './fixed-filter/SelectDateReq.vue'
import SearchBtnAction from '../actions/SearchBtnAction.vue'

export default {
  components: {
    SelectDateReq,
    SearchBtnAction,
  },
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
}
</script>
